import React from 'react';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Modal, Box, Button, Text } from '@rsos/base-components';
import {
  ModalHeader,
  ModalFooter,
} from '@rsos/base-components/Modal/ModalComponents';
import { IconWrapper, ModalDescription } from './Modal.styles';

/**
 * @typedef {Object} ErrorModalProps
 * @property {boolean} [isOpened] - Is the modal open?
 * @property {() => void} [toggleErrorModal] - Callback function to toggle the modal.
 */

/**
 * Call taker mode - error modal.
 * @param {ErrorModalProps} props
 */
const ErrorModal = ({ isOpened = false, toggleErrorModal = () => {} }) => (
  <Modal
    id="call-taker-mode-error-modal"
    isOpened={isOpened}
    onClose={toggleErrorModal}
    padding="45px 45px 35px"
    width={380}
  >
    <ModalHeader onClose={toggleErrorModal}>
      <Box marginBottom="19px">
        <Box
          data-name="modal-title"
          horizontal
          align="center"
          marginBottom="13px"
        >
          <IconWrapper marginRight="8px">
            <AttentionTriangleIcon color="lightDanger" height={15} width={15} />
          </IconWrapper>
          <Text color="primaryText" inline size="xlarge">
            Error: No Position IDs found
          </Text>
        </Box>
        <ModalDescription data-name="modal-description">
          There were no position IDs found. If you have just set up this
          feature, please try again after 1-2 hours. If this problem persists,
          contact your representative at RapidSOS.
        </ModalDescription>
      </Box>
    </ModalHeader>
    <ModalFooter>
      <Button
        btnType="primary"
        dataName="call-taker-mode-close-button"
        grow
        noMargin
        onClick={toggleErrorModal}
      >
        Close
      </Button>
    </ModalFooter>
  </Modal>
);

export default ErrorModal;
